import { Controller } from "@hotwired/stimulus"

// Deja en la barra de direcciones la URL que acaba de cargar un turbo-frame,
// sin navegar la página.
//
// El camino de Turbo para esto es `data-turbo-action="advance"`, pero además
// del frame dispara una VISITA completa: segundo request y re-render de toda
// la página (con morphing, encima). Justo lo que el frame venía a evitar —
// filtrar una tabla tiene que repintar esa tabla y nada más.
//
// Así que la URL se sincroniza a mano con `replaceState`: cero requests, cero
// repintado. El precio es que el filtro no agrega una entrada al historial (el
// back sale de la página en vez de deshacer el filtro); a cambio el link sigue
// siendo copiable y recargable, que es para lo que se mira la URL acá.
export default class extends Controller {
  sync() {
    const src = this.element.getAttribute("src")
    if (!src) return

    window.history.replaceState(window.history.state, "", src)
  }
}
